module.exports = __webpack_public_path__ + "static/img/图层3@2x.52b5db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/底部/图层3@2x.png
// module id = UM06
// module chunks = 192